import {
  ADD_ATTACHMENT_DETAIL,
  ADD_BASIC_DETAIL,
  ADD_COMMENTS_DETAIL,
  ADD_LINE_DETAIL,
  DELETE_ATTACHMENT_DETAIL,
  DELETE_LINE_DETAIL,
  EDIT_LINE_DETAIL,
  CURRENCY_CHANGE,
  STATE_CHANGE,
} from "../constants";

const initialState = {
  id: 0,
  basicValues: {},
  lineData: [],
  attachmentData: [],
  purchase: {},
};

const createEPOReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_BASIC_DETAIL:
      return {
        ...state,
        basicValues: action.basicValues,
      };

    case ADD_LINE_DETAIL:
      function increment(n) {
        state.id = state.id + 1;
        return state.id;
      }
      action.lineData["id"] = increment(state.id);
      return {
        ...state,
        lineData: [...state.lineData, action.lineData],
      };

    case EDIT_LINE_DETAIL:
      var updatedVal = state.lineData.map((edit) => {
        if (edit.id === action.id) {
          return action.editData;
        } else {
          return edit;
        }
      });
      return {
        ...state,
        lineData: updatedVal,
      };

    case DELETE_LINE_DETAIL:
      return {
        ...state,
        lineData: state.lineData.filter((item) => item.id !== action.id),
      };

    case ADD_ATTACHMENT_DETAIL:
      return {
        ...state,
        attachmentData: [...state.attachmentData, action.attachmentData],
      };

    case DELETE_ATTACHMENT_DETAIL:
      return {
        ...state,
        attachmentData: state.attachmentData.filter((item) => {
          return item.AttachmentImage !== action.AttachmentImage;
        }),
      };

    case ADD_COMMENTS_DETAIL:
      return {
        ...state,
        purchase: action.purchase,
      };

    case CURRENCY_CHANGE:
      const pastData = state.lineData;
      if (action.currencyType === 2) {
        pastData.map((x) => {
          return (
            /*eslint-disable */
            (x.productDescription = x?.productDescription),
            (x.productGroup = x?.productGroup),
            (x.department = x?.department),
            (x.accountNo = x?.accountNo),
            (x.uom = x?.uom),
            (x.dueDate = x?.dueDate),
            (x.gujarat = x?.gujarat),
            (x.cgstValue = x?.cgstValue),
            (x.sgstValue = x?.sgstValue),
            (x.igstValue = x?.igstValue),
            (x.cgst = x?.cgst),
            (x.sgst = x?.sgst),
            (x.purchase = x?.purchase),
            (x.extendedCost = x?.extendedCost / action.dollarPrice),
            (x.qty = x?.qty),
            (x.unitPrice = x?.unitPrice / action.dollarPrice),
            (x.igst = x?.igst),
            (x.tax = x?.tax),
            (x.gst = x?.gst),
            (x.discount = x?.discount),
            (x.id = x?.id)
            /*eslint-enable */
          );
        });
      } else {
        pastData.map((x) => {
          return (
            /*eslint-disable */
            (x.productDescription = x?.productDescription),
            (x.productGroup = x?.productGroup),
            (x.department = x?.department),
            (x.accountNo = x?.accountNo),
            (x.uom = x?.uom),
            (x.dueDate = x?.dueDate),
            (x.gujarat = x?.gujarat),
            (x.cgstValue = x?.cgstValue),
            (x.sgstValue = x?.sgstValue),
            (x.igstValue = x?.igstValue),
            (x.cgst = x?.cgst),
            (x.sgst = x?.sgst),
            (x.purchase = x?.purchase),
            (x.extendedCost = x?.extendedCost * action.dollarPrice),
            (x.qty = x?.qty),
            (x.unitPrice = x?.unitPrice * action.dollarPrice),
            (x.igst = x?.igst),
            (x.tax = x?.tax),
            (x.gst = x?.gst),
            (x.discount = x?.discount),
            (x.id = x?.id)
            /*eslint-enable */
          );
        });
      }
      return { ...state, lineData: pastData };

    case STATE_CHANGE:
      const dataPast = state.lineData;
      if (action.stateType === false) {
        dataPast.map((x) => {
          return (
            /*eslint-disable */
            (x.productDescription = x?.productDescription),
            (x.productGroup = x?.productGroup),
            (x.department = x?.department),
            (x.accountNo = x?.accountNo),
            (x.uom = x?.uom),
            (x.dueDate = x?.dueDate),
            (x.gujarat = true),
            (x.igstValue = x?.cgstValue + x?.sgstValue),
            (x.cgstValue = 0),
            (x.sgstValue = 0),
            (x.igst = x?.cgst + x?.sgst),
            (x.cgst = 0),
            (x.sgst = 0),
            (x.purchase = x?.purchase),
            (x.extendedCost = x?.extendedCost),
            (x.qty = x?.qty),
            (x.unitPrice = x?.unitPrice),
            (x.tax = x?.tax),
            (x.gst = x?.gst),
            (x.discount = x?.discount),
            (x.id = x?.id)
            /*eslint-enable */
          );
        });
      } else {
        dataPast.map((x) => {
          return (
            /*eslint-disable */
            (x.productDescription = x?.productDescription),
            (x.productGroup = x?.productGroup),
            (x.department = x?.department),
            (x.accountNo = x?.accountNo),
            (x.uom = x?.uom),
            (x.dueDate = x?.dueDate),
            (x.gujarat = true),
            (x.cgstValue = x?.igstValue / 2),
            (x.sgstValue = x?.igstValue / 2),
            (x.igstValue = 0),
            (x.cgst = x?.igst / 2),
            (x.sgst = x?.igst / 2),
            (x.igst = 0),
            (x.purchase = x?.purchase),
            (x.extendedCost = x?.extendedCost),
            (x.qty = x?.qty),
            (x.unitPrice = x?.unitPrice),
            (x.tax = x?.tax),
            (x.gst = x?.gst),
            (x.discount = x?.discount),
            (x.id = x?.id)
            /*eslint-enable */
          );
        });
      }
      return { ...state, lineData: dataPast };

    default: {
      return state;
    }
  }
};
export default createEPOReducer;
